import { render, staticRenderFns } from "./PageLayout.vue?vue&type=template&id=629c9159&scoped=true&"
var script = {}
import style0 from "./PageLayout.vue?vue&type=style&index=0&id=629c9159&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "629c9159",
  null
  
)

component.options.__file = "PageLayout.vue"
export default component.exports